#import "~/graphql/fragments/User.graphql"

mutation UpdateUserAvatar(
    $file: Upload!
) {
    updateUserAvatar(file: $file) {
        ...User
    }
}